// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationShoppingPath = 'M42 11c6.147 0 11.298 4.267 12.652 10H29.348C30.702 15.267 35.853 11 42 11zm0-7c-10.026 0-18.329 7.377-19.776 17H1l7.7 57.9A10.5 10.5 0 0019.1 88h20.012a40.593 40.593 0 01-.712 2.4L36.9 95h62.2l-1.6-4.6c-3.252-9.758-4.454-29.04-4.795-34.518-.058-.922-.09-1.453-.105-1.482V51H79.449L82.9 21H61.776C60.33 11.377 52.026 4 42 4zm30.368 47L75.1 28H9l6.7 50a3.4 3.4 0 003.4 3h21.488c1.644-9.663 2.357-21.1 2.607-25.118.057-.922.09-1.453.105-1.482V51h29.068zM55.5 63c0 6.904 5.596 12.5 12.5 12.5S80.5 69.904 80.5 63h-7a5.5 5.5 0 11-11 0h-7zm-9.1 25h43.2c-2.3-10-3.3-23.7-3.7-30H50.1c-.4 6.3-1.4 20-3.7 30z';
var IllustrationShopping = baseIllustration('IllustrationShopping', {
  getPath: () => IllustrationShoppingPath
}, 'ColoredIllustrationShopping');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationShopping;
//# sourceMappingURL=index.js.map